import SimplePricing from "./components/simplePricing.component";
import CoinTopUp from "./components/coinTopUp.component";
import SubscriptionManagement from "./components/subscriptionManagement.component";
import InvoiceManagement from "./components/invoiceManagement.component";

/**
 * Pricing Page - Shows subscription plans
 *
 * Displays Free, Starter (€8.99/mo), and Creator (€18.99/mo) plans
 * Includes coin top-ups for active subscribers, subscription management
 * (cancel/reactivate) and invoice history
 */
const PricingPage = () => {
	return (
		<div className="flex-1 overflow-y-auto pb-16 md:pb-8">
			<SimplePricing />
			<div className="mx-auto max-w-6xl px-4 md:px-6 pt-8 space-y-6">
				<CoinTopUp source="pricing_page" />
				<SubscriptionManagement />
				<InvoiceManagement />
			</div>
		</div>
	);
};

export default PricingPage;
